import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.sass';
import * as serviceWorker from './serviceWorker';
import AppProvider from './AppProvider';
import "@babel/polyfill";

const rootElement = document.getElementById('root');
ReactDOM.render(<AppProvider />, rootElement);

if (module.hot) {
	module.hot.accept('./AppProvider', () => {
		const NextAppProvider = require('./AppProvider').default
		ReactDOM.render(
			<NextAppProvider />,
			rootElement
		)
	})
}

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
